import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect } from 'react';
import NativeCapability from '~/constants/vdp/nativeCapability';
import { useIsNativeCapabilityActive } from '~/context/common/NativeContext';
import ModalContext from '~/context/vdp/ModalContext';
import { NativeModalId } from '~/context/vdp/ModalContext/constants';
import sendMessageToNative from './sendMessageToNative';

// Tell the native app to open modals
function sendMessageToOpenNativeModal(
  modal: NativeModalId,
  onError: () => void,
  payload: Record<string, any> = {}
) {
  sendMessageToNative(
    DispatcherEvent.OpenModal,
    { modal, ...payload },
    { onError }
  );
}

export default function useModalMessageDispatcher() {
  const {
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isGeolocationModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setGeolocationModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);

  const shouldUseGeolocationWebView = useIsNativeCapabilityActive(
    NativeCapability.GeolocationWebView
  );

  useEffect(() => {
    if (isGeolocationModalOpen && !shouldUseGeolocationWebView) {
      sendMessageToOpenNativeModal(NativeModalId.Geolocation, () => {
        setGeolocationModalOpen(false);
      });
    }

    if (
      isAddCoApplicantModalOpen ||
      isEditCoApplicantModalOpen ||
      isSoftPullModalOpen
    ) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () => {
        setSoftPullModalOpen(false);
        setAddCoApplicantModalOpen(false);
        setEditCoApplicantModalOpen(false);
      });
    }
  }, [
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isGeolocationModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setGeolocationModalOpen,
    setSoftPullModalOpen,
    shouldUseGeolocationWebView
  ]);
}
